import React from 'react';
import { HomePage } from './HomePage';

export function SwedishHome({ search = '' }: { search?: string }) {
  return <HomePage locale="sv" search={search} />;
}
